"use client";

import type { A8CampaignKey } from "@/lib/a8-campaigns";
import { A8_CAMPAIGNS, affiliateTrackPath } from "@/lib/a8-campaigns";
import { trackEvent } from "@/lib/gtag";

const VARIANT_CLASS = {
  primary:
    "inline-flex w-full sm:w-fit items-center justify-center text-center bg-accent text-white rounded-lg px-5 py-3 text-sm font-semibold leading-snug hover:bg-accent-hover transition-colors",
  outline:
    "inline-flex w-full sm:w-fit items-center justify-center text-center border border-accent bg-white text-accent rounded-lg px-5 py-2.5 text-sm font-semibold leading-snug hover:bg-accent hover:text-white transition-colors",
  text: "text-accent underline underline-offset-2 hover:text-accent-hover",
} as const;

export function AffiliateLink({
  campaign,
  placement,
  children,
  variant = "primary",
}: {
  campaign: A8CampaignKey;
  placement: string;
  children: string;
  variant?: keyof typeof VARIANT_CLASS;
}) {
  const offer = A8_CAMPAIGNS[campaign];

  return (
    <span className={variant === "text" ? "inline" : "block max-w-full"}>
      <a
        href={affiliateTrackPath(campaign, placement)}
        target="_blank"
        rel="nofollow sponsored noopener noreferrer"
        className={VARIANT_CLASS[variant]}
        onClick={() => {
          trackEvent("click", {
            link_url: offer.href,
            link_domain: "px.a8.net",
            link_text: children,
            outbound: true,
            placement,
          });
        }}
      >
        {children}
      </a>
      {/* A8の1x1インプレッション計測。URLを最適化すると計測できないため img のままにする */}
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={offer.impression}
        width={1}
        height={1}
        alt=""
        style={{ border: 0 }}
      />
    </span>
  );
}
